import { BriefcaseIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { API_CALLS as JOB_OPPORTUNITIES_API } from '~/features/provider-hlx/job-opportunities/api';
import type { JobOpportunity } from '~/features/provider-hlx/job-opportunities/types';
import { paths } from '~/routing';
import { getHlxNavIcon } from '~/routing/hlxNavIcons';

// [MCV-1516] Resolve through the shared map instead of hardcoding — this was
// already the sidebar's icon by coincidence, but drifted from the map's
// single source of truth.
export const JobsIcon = getHlxNavIcon(paths.hlx.jobOpportunities) ?? BriefcaseIcon;

export const UpcomingJobsCard = () => {
  const navigate = useNavigate();
  const [opportunities, setOpportunities] = useState<JobOpportunity[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    JOB_OPPORTUNITIES_API.getOpportunities('accepted')
      .then(({ items }) => setOpportunities(items))
      .catch(() => setOpportunities(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-grey-900 p-6 animate-pulse">
        <div className="h-5 bg-grey-900 rounded w-1/3 mb-4" />
        <div className="grid grid-cols-2 gap-4">
          <div className="h-12 bg-grey-900 rounded" />
          <div className="h-12 bg-grey-900 rounded" />
        </div>
      </div>
    );
  }

  if (!opportunities) return null;

  const now = new Date();
  const upcoming = opportunities.filter(
    (o) => o.listing.startDate != null && new Date(o.listing.startDate) > now
  ).length;

  return (
    <button
      type="button"
      className="bg-white rounded-xl shadow-sm border border-grey-900 p-6 w-full text-left hover:shadow-md transition-shadow"
      onClick={() => navigate(paths.hlx.jobOpportunities)}
    >
      <div className="flex items-center gap-2 mb-4">
        <JobsIcon className="size-5 text-primary-50" />
        <h3 className="sub-heading-sb text-grey-100">Upcoming Jobs</h3>
        <span className="ml-auto caption-text text-primary-50">View all →</span>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-2xl font-bold text-success">{upcoming}</p>
          <p className="body-text text-grey-500">Upcoming</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-grey-100">{opportunities.length}</p>
          <p className="body-text text-grey-500">Accepted</p>
        </div>
      </div>
    </button>
  );
};
